



































import EmployeSelect from "../../core/Forms/EmployeSelect.vue";
import DateInput from "../../core/Forms/DateInput.vue";
import { RecurrenceIntervention } from "../../models/RecurrenceIntervention";
import Remplacement = RecurrenceIntervention.Remplacement;

export default {
    name: "RemplacementModalEdit",
    components: {
        DateInput,
        EmployeSelect,
    },
    props: {
        remplacement: Remplacement,
    },
    data() {
        return {};
    },
    methods: {},
};
